import {
  collection,
  doc,
} from 'firebase/firestore';

import {
  db,
} from '@/services/firebase.js';

import {
  converters,
} from '../converters/index.js';

export const workspace_member_refs = {
  document: ({
    workspace_id,
    workspace_member_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'workspace_members',
      workspace_member_id,
    ].join('/');
    return doc(db, path).withConverter(converters.workspace_members);
  },
  collection: ({
    workspace_id,
  }) => {
    const path = [
      'workspaces',
      workspace_id,
      'workspace_members',
    ].join('/');
    return collection(db, path).withConverter(converters.workspace_members);
  },
};


